/* eslint-disable */

/** unique or primary key constraints on table "argo.user" */
export enum ArgoUserConstraint {
  /** unique or primary key constraint on columns "user_id" */
  UserPkey = 'user_pkey',
  /** unique or primary key constraint on columns "username" */
  UserUsernameKey = 'user_username_key'
}

/** select columns of table "argo.user" */
export enum ArgoUserSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username'
}

/** update columns of table "argo.user" */
export enum ArgoUserUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username'
}

